// frontend/modules/account-settings/hooks/useTransaccManagement.ts
import { useState } from 'react';
import { useGetAllCoas } from '@/shared/api/client/coa-resource';
import {
    useGetAllTransaccs,
    useCreateTransacc,
    useUpdateTransacc,
    useDeleteTransacc
} from '@/shared/api/client/transacc-resource';
import createParamsSerializer from "@/shared/utils/create-params-serializer";
import {TransaccDTO} from "@/shared/api/model";

export const useTransaccManagement = () => {
    const [selectedGl, setSelectedGl] = useState<string>('');
    const [accountType, setAccountType] = useState<number>(0);
    // Fetch COA list
    // Then use it like this:
    const { data: coaResponse } = useGetAllCoas({
        criteria: {
            header: {
                equals: false
            }
        },
        pageable: {
            page: 0,
            size: 20,
            sort: ["glNo,asc"]
        }
    }, {
        request: {
            paramsSerializer: createParamsSerializer()
        }
    });

    // @ts-ignore
    // Fetch Transacc list
    const { data: transaccResponse, refetch } = useGetAllTransaccs({});

    // Mutations
    const createMutation = useCreateTransacc();
    const updateMutation = useUpdateTransacc();
    const deleteMutation = useDeleteTransacc();

    const handleCreate = async (data: TransaccDTO) => {
        await createMutation.mutateAsync({ data });
        refetch();
    };

    const handleUpdate = async (data: TransaccDTO) => {
        await updateMutation.mutateAsync({ data });
        refetch();
    };

    const handleDelete = async (data: TransaccDTO) => {
        const { glNo, acNo } = data;
        if(!glNo||!acNo) return;
        await deleteMutation.mutateAsync({ glNo, acNo });
        refetch();
    };

    return {
        coaList: coaResponse || [],
        transaccList: transaccResponse || [],
        selectedGl,
        setSelectedGl,
        accountType,
        setAccountType,
        handleCreate,
        handleUpdate,
        handleDelete,
        isLoading: createMutation.isPending || updateMutation.isPending || deleteMutation.isPending
    };
};